import { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";
import { useLandingSettings } from "@/hooks/useLandingPage";
import Landing from "@/pages/Landing";

/**
 * Wraps public marketing routes. When the landing page is enabled with
 * single page mode on, every public route renders the landing page instead,
 * so the site behaves as one single page. Admins can bypass with ?site=1.
 */
export function SinglePageGate({ children }: { children: ReactNode }) {
  const [searchParams] = useSearchParams();
  const bypass = searchParams.get("site") === "1";
  const { data: settings, isLoading } = useLandingSettings();

  if (bypass) return <>{children}</>;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (settings?.is_enabled && settings?.single_page_mode !== false) {
    return <Landing />;
  }

  return <>{children}</>;
}

export default SinglePageGate;
